import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { TimeChallengeComponent } from '../time-challenge.component';
import { CloseConfirmComponent } from 'src/app/admin/close-confirm/close-confirm.component';
import * as moment from 'moment';

@Component({
  selector: 'vex-edit-week-time-challenge',
  templateUrl: './edit-week-time-challenge.component.html',
  styleUrls: ['./edit-week-time-challenge.component.scss']
})
export class EditWeekTimeChallengeComponent implements OnInit {
  week;
  publishAt;
  videos = [];
  newVideo: boolean = false;
  editingVideo = null;
  videoToAdd: any = { i18nTitle: {EN: "",IT: ""}, pdf: {EN: "", IT: ""}, videoId: {EN: "", IT: ""}, i18nDescription: {EN: "", IT: ""} };

  constructor(@Inject(MAT_DIALOG_DATA) public item: any['item'], private dialogRef: MatDialogRef<TimeChallengeComponent>, public translate: TranslateService, public restService: RestService, public guiService: GuiService, private dialog: MatDialog) { }

  ngOnInit(): void {
    console.debug(this.item)
    this.week = this.item.weekIndex;
    const weekIndex = this.item.weekIndex;
    const challengeIndex = this.item.challengeIndex;
    this.videos = this.item.challenge.challenges[challengeIndex].weeks[weekIndex].videos;
    this.publishAt = new Date(this.item.challenge.challenges[challengeIndex].weeks[weekIndex].publishDate);
  }

  confirmClose() {
    this.dialog.open(CloseConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      panelClass: 'close-dialog-modalbox'
    }).afterClosed().subscribe((ris) => {
      if (ris == 'true') {
        this.dialogRef.close()
      }
    })
  }

  submit() {

    setTimeout(() => this.guiService.showSpinner = true, 0)
    const param = {
      userId: this.guiService.userLogged.user.id,
      challengeId: this.item.challenge._id,
      challengeIndex: this.item.challengeIndex,
      weekIndex: this.item.weekIndex,
      newWeekData: {
        videos: this.videos,
        publishDate: moment(this.publishAt).format('YYYY-MM-DD')
      }
    };
    this.restService.postService('node', '/update-week-challenge', param).subscribe((ris) => {
      this.guiService.showSpinner = false;
      this.dialogRef.close('done')
    })
  }

  addVideo(){
    this.videos.push(this.videoToAdd);
    this.videoToAdd = { i18nTitle: {EN: "",IT: ""}, pdf: {EN: "", IT: ""}, videoId: {EN: "", IT: ""}, i18nDescription: {EN: "", IT: ""} };
    this.newVideo = false;
    console.debug(this.videos);
  }

  cancelAddVideo(){
    this.videoToAdd = { i18nTitle: {EN: "",IT: ""}, pdf: {EN: "", IT: ""}, videoId: {EN: "", IT: ""}, i18nDescription: {EN: "", IT: ""} };
    this.newVideo = false;
    this.editingVideo = null;
  }

  isVideoToAddValid(): boolean {
    const fields = ['i18nTitle', 'videoId', 'i18nDescription'];
    const languages = ['EN', 'IT'];

    for (const field of fields) {
      for (const lang of languages) {
        const value = this.videoToAdd[field]?.[lang];
        if (!value || value.trim() === '') {
          return false;
        }
      }
    }

    return true;
  }

  moveVideo(direction: string, videoIndex: number) {

    if (direction === 'up') {
      let itemToMove = this.videos.splice(videoIndex, 1)[0];
      this.videos.splice(videoIndex - 1, 0, itemToMove)
    } else {
      let itemToMove = this.videos.splice(videoIndex, 1)[0];
      this.videos.splice(videoIndex + 1, 0, itemToMove)
    }
  }

  editVideo(i){
    this.newVideo = true;
    this.editingVideo = i;
    this.videoToAdd = this.videos[i];
  }

  confirmEditVideo(){
    this.videos[this.editingVideo] = this.videoToAdd;
    this.newVideo = false;
    this.editingVideo = null;
    this.videoToAdd = { i18nTitle: {EN: "",IT: ""}, pdf: {EN: "", IT: ""}, videoId: {EN: "", IT: ""}, i18nDescription: {EN: "", IT: ""} };
  }

  deleteVideo(i){
    this.videos.splice(i, 1)
  }
}
